import React from 'react';

const defaultValues = {
  selectedItemsDocIds: [],
  selectedItemsIds: [],
  setSelectedItemsDocIds: (e) => {},
  setSelectedItemsIds: (e) => {},
};

const DocsCtx = React.createContext(defaultValues);

export default DocsCtx;
